import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=5ec7dda4&scoped=true&"
import script from "./Inventory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Inventory.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec7dda4",
  null
  
)

export default component.exports